import $defaultVertex from './default.mjs';
import $defaultFilterVertex from './defaultFilter.mjs';

const defaultVertex = $defaultVertex;
const defaultFilterVertex = $defaultFilterVertex;

export { defaultFilterVertex, defaultVertex };
//# sourceMappingURL=index.mjs.map
